import { motion } from "framer-motion";
import { EVOLUTIONS } from "@/data/temple";
import { Eyebrow, Reveal } from "./Reveal";

export default function Evolutions() {
  return (
    <section data-testid="evolutions-section" className="relative overflow-hidden bg-[#5A0F1A]/25 border-y border-[#C2414F]/20">
      <img src="/images/couple.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
      <div className="absolute inset-0 bg-[#0A0706]/70" />
      <div className="relative max-w-[1440px] mx-auto px-5 sm:px-10 py-28 sm:py-40">
        <Reveal>
          <Eyebrow n="VI">The Three Evolutions of Tantric Mastery</Eyebrow>
          <blockquote className="font-display text-3xl sm:text-4xl lg:text-5xl mt-10 max-w-5xl leading-[1.15]">
            “Tantric mastery is not measured by performance. It is measured by <em className="text-[#D9B47A]">presence</em>,
            sensitivity, integrity.”
          </blockquote>
        </Reveal>
        <div className="mt-20 grid md:grid-cols-3 gap-px bg-[#D9B47A]/20">
          {EVOLUTIONS.map((e, i) => (
            <motion.div
              key={e.n}
              data-testid={`evolution-${i + 1}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 1, delay: i * 0.15 }}
              className="group bg-[#0E0908] p-8 sm:p-10 min-h-[340px] flex flex-col hover:bg-[#1A0D0D] transition-colors duration-700"
            >
              <span className="font-display italic text-7xl text-[#C2414F] group-hover:text-[#D9B47A] transition-colors duration-700">{e.n}</span>
              <h3 className="font-display text-3xl mt-auto pt-10">{e.t}</h3>
              <p className="mt-4 text-[15px] text-[#CFC2B6] leading-relaxed">{e.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
